export default class AumDetails {
  constructor() {
    this.clUserId = '';
    this.dailyAums = [];
    this.endingAumDate = '';
    this.riaId = '';
    this.startingAumDate = '';
  }
}
